import { render } from "./tests-en.vue?vue&type=template&id=1ec04e87&scoped=true"
import script from "./tests-en.vue?vue&type=script&lang=js"
export * from "./tests-en.vue?vue&type=script&lang=js"

import "./tests-en.vue?vue&type=style&index=0&id=1ec04e87&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec04e87"]])

export default __exports__